export default {
  agent_status: {
    name: null,
  },
  agent: {
    agent_code: null,
    name: null,
    alias: null,
    email: null,
    description: null,
    mobile_phone: null,
    phone_number: null,
    address: null,
    status: null,
    lat: null,
    long: null,
    minimal_purchase: null,
    parent: null,
    parent_flag:null,
  },
  agent_coverage: {
    agent_code: null,
    province: null,
    district: null,
    regencies: null,
    villages: null,
  },
  owner_coverage: {
    freezer_owner_code: null,
    province: null,
    district: null,
    regencies: null,
    villages: null,
  },
  agent_coverage_user: {
    agent_code: null,
    user_group: null,
  },
  agent_delivery_method: {
    agent_code: null,
    delivery: null,
  },
  agent_payment_method: {
    agent_code: null,
    payment_method: null,
  },
  order_status: {
    name: null,
    ordering: null,
    description: null,
  },
  payment_method: {
    name: null,
    account_number: null,
    status: null,
    description: null,
    images: null,
    group: null,
    ordering: null,
    payment_channel: null,
  },
  product_issue_type: {
    name: null,
    description: null,
  },
  product_status: {
    name: null,
    description: null,
  },
  contact_us: {
    user_code: null,
    messages: null,
    date_inserted: null,
  },
  contact_us_discussion: {
    ticket_number: null,
    response_by: null,
    response_by_agent: null,
    messages: null,
    date_inserted: null,
  },
  dashboard:{
    agent:null,
  },
  delivery: {
    name: null,
    alias: null,
    description: null,
    using_resi: null,
    status: null,
  },
  product_category: {
    name: null,
    parent: null,
    group: null,
    flag: null,
    description: null,
    images: null,
  },
  delivery_type: {
    name: null,
    delivery: null,
    price: null,
    time_estimation: null,
    status: null,
    province: null,
    regencies: null,
    district: null,

  },
  delivery_status: {
    id: null,
    name: null,
    description: null,
  },
  delivery_type_status: {
    id: null,
    name: null,
    description: null,
  },
  product_group: {
    name: null,
    description: null,
    shortcut: null,
    ordering: null,
    icon: null,
    flag: null,
    show: null,
  },
  product_issue: {
    issue_code: null,
    issue_type: null,
    product_code: null,
    user_code: null,
    description: null,
    date_inserted: null,
  },
  product_price: {
    product_code: null,
    price: null,
    user_group: null,
  },
  freezer_serialnmb: {
    id:null,
    freezer_code: null,
    serial_number: null,
  },
  promotion: {
    title: null,
    images: null,
    images_on_page: null,
    status: null,
    ordering: null,
    description: null,
    flag: null,
    view_on_web: null,
    view_on_apps: null,
    view_on_voucher_page: null,
  },
  product_point: {
    product_code: null,
    points: null,
    referal: null,
    flag: null,
  },
  notification: {
    user_code: null,
    title: null,
    messages: null,
    notification_type: null,
    read: null,
    date_inserted: null,
    time_read: null,
  },
  notification_type: {
    name: null,
    description: null,
  },
  users: {
    user_code: null,
    password: null,
    name: null,
    email: null,
    mobile_phone: null,
    status: null,
    uuid: null,
    date_inserted: null,
    points: null,
    user_group: null,
    user_type: null,
  },
  users_address: {
    user_code: null,
    title: null,
    address: null,
    recipient_name: null,
    recipient_phone: null,
    lat: null,
    long: null,
    province: null,
    district: null,
    regencies: null,
    villages: null,
    primary: null,
    flag: null,
  },
  user_type: {
    id: null,
    name: null,
    description: null,
  },
  user_group: {
    id: null,
    name: null,
    description: null,
    status: null,
  },
  user_freezer_request: {
    status:null,
    freezer_code: null,
    serial_number:null
  },
  products: {
    product_code: null,
    agent_code: null,
    group: null,
    parent_category: null,
    category: null,
    name: null,
    title: null,
    price: null,
    qty: null,
    installment: null,
    description: null,
    images: null,
    quantity: null,
    product_unit: null,
    status: null,
    packaging_size: null,
    brand: null,
  },
  product_unit: {
    name: null,
    description: null,
  },
  freezers: {
    freezer_code: null,
    freezer_owner_code: null,
    name:null,
    brand: null,
    sku:null,
    capacity:null,
    slot:null,
    weight:null,
    voltage:null,
    dimention:null,
    description:null,
    image_information: null,
  },
  freezer_owner: {
    freezer_owner_code: null,
    name:null,
    email: null,
    mobile_phone:null,
    phone:null,
    address:null,
    description:null,
    status:null
  },
  confirmation_payment: {
    order_number: null,
    user_code: null,
    account_no: null,
    account_name: null,
    payment_date: null,
    picture: null,
    date_inserted: null,
  },
  order: {
    agent_code: null,
    order_number: null,
    user_code: null,
    date_order: null,
    delivery: null,
    delivery_type: null,
    payment_method: null,
    delivery_address: null,
    delivery_time: null,
    notes: null,
    no_resi: null,
    status: null,
    reason: null,
  },
  order_detail: {
    order_number: null,
    product_code: null,
    qty: null,
    price: null
  },
  complaint: {
    complaint_type: null,
    order_number: null,
    user_code: null,
  },
  complaint_type: {
    name: null,
    description: null,
  },
  complaint_detail: {
    complaint_id: null,
    messages: null,
    response_by: null,
    response_by_agent: null,
    response_time: null,
    attachment: null,
  },
  voucher: {
    voucher_code: null,
    voucher_group: null,
    name: null,
    abbreviation: null,
    start_date: null,
    end_date: null,
    voucher_type: null,
    price: null,
    percentage: null,
    images: null,
    max_price: null,
    description: null,
    tnc: null,
    status: null,
    min_transaction: null,
    payment:null,
    voucher_group:null,
  },
  voucher_group: {
    name: null,
    description: null,
  },
  voucher_product: {
    agent_code: null,
    voucher_code: null,
    product_code: null,
  },
  voucher_users: {
    voucher_code: null,
    user_code: null,
  },
  voucher_upload_images: {
    images: null
  },
  voucher_product_qr:{
    voucher_code: null,
    agent_code: null,
    product_code: null,
    qty: null,
  },
  faq: {
    title: null,
    description: null,
    show: null,
  },
  video: {
    title: null,
    url: null,
    description: null,
    page:null,
    show: null,
    order: null,
    media: null
  },
  villages: {
    Villages_code: null,
    district_id: null,
    zipcode:null,
    name: null,
    description: null,
    order: null,
  },
  district: {
    regencies_id: null,
    district_code: null,
    name: null,
    description: null,
    order: null,
  },
  regencies: {
    regency_code: null,
    province_id: null,
    name: null,
    description: null,
    order: null,
  },
  province: {
    id: null,
    province_code: null,
    name: null,
    order: null,
    description: null,
  },
  religion: {
    id: null,
    name: null,
    description: null,
  },
  change_password: {
    new_password: null,
    confirmation_new_password: null
  },
  generate_password: {
    password: null
  },
  user_document: {
    ktp: null,
    selfie: null,
    user_code: null
  },
  user_voucher: {
    user_code: null,
    voucher_code: null
  },
  agent_voucher: {
    agent_code: null,
    voucher_code: null
  },
  blast_voucher: {
    user_group: null,
    user_comunity: null,
    voucher_code: null
  },
  user_access_menu: {
    user_code: null,
    menu: null,
  },
  administrator:{
    admin_code:null,
    name:null,
    email:null,
    password:null,
  },
  administrator_detail:{
    admin_code:null,
    description:null,
    name:null,
    email:null,
    password:null,
    new_password:null,
  },
  administrator_access_menu: {
    admin_code: null,
    menu: null,
  },
  terms_and_condition: {
    id: null,
    description: null,
  },
  menu: {
    id: null,
    code: null,
    name: null,
    url: null,
    parent: null,
    icon: null,
    badge: null,
    is_title: null,
    ordering: null,
    is_agent: null,
  },
  cancellation_order: {
    cancellation_type: null,
    order_number: null,
    user_code: null,
    status: null
  },
  cancellation_order_type: {
    name: null,
    description: null,
  },
  cancellation_order_detail: {
    cancellation_id: null,
    messages: null,
    attachment: null,
    response_by: null,
    response_by_agent: null,
    response_time: null,
    attachment: null,
  },
  questions: {
    code: null,
    name: null,
    parent: null,
    messages: null,
    end: null,
  },
  upload_images_product: {
    upload_type: null,
    images: null,
    url_video: null
  },
  user_comunity: {
    user_code: null,
    comunity_id: null
  },
  comunity: {
    name: null,
    description: null
  },
  partnership:{
    parnership_code:null,
    user_code:null,
    partnership_group:null,
    status:null,
    date_inserted:null,
    approved_time:null,
    approved_by:null
  },
  partnership_group:{
    name: null,
    images: null,
    opening_description: null,
    closing_description: null,
    show: null
  },
  partnership_answer:{
    partnership_code:null,
    partnership_question:null,
    answer_option:null,
    answer:null,
  },
  partnership_document:{
    partnership_code:null,
    document:null,
    flag:null
  },
  partnership_options:{
    partnership_question: null,
    name: null,
    ordering: null
  },

  video_education:{
    category: null,
    url: null,
    ordering: null,
    description: null,
    flag: null,
  },

  video_education_category:{
    name: null,
    description: null,
  }

};